/**
 * The date pairs of Advanced (BI)'s form (CU-869fmk5ge D8, TL B2).
 *
 * - A pick-up range that is empty or not a real date stays empty (`null`), so the schema asks for it: the form no
 *   longer queries "today" while the field looks empty (goal 3 leaves it to choose).
 * - The capture range keeps today's fallback, now also over an `Invalid Date` — truthy, it slipped past `|| new Date()`
 *   and made `format` throw (`stringToDate(undefined)`, `getNextDate({ days: 0 }, null)`).
 * - A change of the capture range copies it into the pick-up as before, except when the capture was cleared (the ✕
 *   emits `[null, null]`) or the pick-up is empty: that crashed BI (X2) / would invent a pick-up (CA 5).
 *
 * Imports only alias-free modules: `node --test` runs it.
 */
import { fromIso, startOfDay, toCompact } from '../../../Dashboards/@services/dates.js'

export const isDay = d => d instanceof Date && !Number.isNaN(d.getTime())

const both = range => Array.isArray(range) && isDay(range[0]) && isDay(range[1])

/** `{ startPickupDate, endPickupDate }`: compact days, or both `null` */
export function formPickup(range) {
	return both(range)
		? { startPickupDate: toCompact(range[0]), endPickupDate: toCompact(range[1]) }
		: { startPickupDate: null, endPickupDate: null }
}

/** `{ startBookingDate, endBookingDate }`: compact days, today for a missing or invalid one */
export function formCapture(range, today = new Date()) {
	const day = d => toCompact(isDay(d) ? d : startOfDay(today))
	const r = Array.isArray(range) ? range : []
	return { startBookingDate: day(r[0]), endBookingDate: day(r[1]) }
}

/** The range of two `yyyyMMdd` of a link or a saved query: `[]` unless both are calendar days */
export function rangeFromForm(start, end) {
	const a = fromIso(start), z = fromIso(end)
	return a && z && /^\d{8}$/.test(String(start)) && /^\d{8}$/.test(String(end)) ? [a, z] : []
}

/** The pick-up after "Booking date range" changes to `capture` */
export function pickupAfterCaptureChange(capture, pickup) {
	if (!both(capture)) return pickup
	if (!both(pickup)) return pickup
	return [startOfDay(capture[0]), startOfDay(capture[1])]
}
